import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { DvlaLookupService }      from './dvla-lookup.service';
import { DVLALookupSettingsCtrl } from './dvla-lookup.settings';
import { DVLALookupStates }       from './dvla-lookup.states.ajs';

angular.module('app-lite.dvla-lookup', [])
  .config(DVLALookupStates)
  .controller('DVLALookupSettingsCtrl', DVLALookupSettingsCtrl)
  .service('dvlaLookupApi', downgradeInjectable(DvlaLookupService));